import { render, staticRenderFns } from "./ImportOTDoubleForm.vue?vue&type=template&id=4fa79914&scoped=true"
import script from "./ImportOTDoubleForm.vue?vue&type=script&lang=js"
export * from "./ImportOTDoubleForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa79914",
  null
  
)

export default component.exports